(function() {
  if (window.HatchillAppMotion) return;

  var animePromise = null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function loadAnime(src) {
    if (prefersReducedMotion() || !src) return Promise.resolve(null);
    if (window.anime) return Promise.resolve(window.anime);
    if (animePromise) return animePromise;

    animePromise = new Promise(function(resolve) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function() { resolve(window.anime || null); };
      script.onerror = function() { resolve(null); };
      document.head.appendChild(script);
    });

    return animePromise;
  }

  function finish(callback) {
    if (typeof callback === 'function') callback();
  }

  function fixed(value) {
    return Number(value).toFixed(3);
  }

  function clearElementStyle(element, properties) {
    if (!element) return;
    properties.forEach(function(property) {
      element.style[property] = '';
    });
  }

  function clearBannerFrame(banner) {
    if (!banner) return;

    clearElementStyle(banner, ['boxShadow', 'filter']);
    clearElementStyle(banner.querySelector('.hatchill-app-banner__icon'), ['transform']);
    clearElementStyle(banner.querySelector('.hatchill-app-banner__copy'), ['opacity', 'transform']);
    clearElementStyle(banner.querySelector('.hatchill-app-banner__cta'), ['boxShadow', 'filter', 'transform']);
  }

  function clearModalFrame(modal) {
    if (!modal) return;

    var stage = modal.querySelector('.hatchill-app-modal__stage');
    var icon = modal.querySelector('.hatchill-app-modal__icon');
    var mark = icon && (icon.querySelector('img') || icon.querySelector('span') || icon);
    var cta = modal.querySelector('.hatchill-app-modal__cta');

    clearElementStyle(stage, ['boxShadow', 'filter', 'transform']);
    clearElementStyle(icon, ['boxShadow', 'filter', 'transform']);
    clearElementStyle(mark, ['filter', 'transform']);
    clearElementStyle(cta, ['boxShadow', 'filter', 'transform']);
  }

  function runLoop(surface, key, play, maxCycles) {
    var token = String(Date.now());
    var cycles = 0;
    var cycleLimit = maxCycles || 2;
    surface.dataset[key] = token;

    function next() {
      if (surface.dataset[key] !== token || surface.hidden || !document.documentElement.contains(surface)) return;
      if (cycles >= cycleLimit) {
        delete surface.dataset[key];
        return;
      }
      cycles += 1;
      play(token, function() {
        window.setTimeout(next, 80);
      });
    }

    next();
  }

  function runBannerIdle(anime, banner) {
    var icon = banner.querySelector('.hatchill-app-banner__icon');
    var copy = banner.querySelector('.hatchill-app-banner__copy');
    var cta = banner.querySelector('.hatchill-app-banner__cta');
    var targets = [banner, icon, copy, cta].filter(Boolean);

    anime.remove(targets);

    runLoop(banner, 'hatchillBannerLoop', function(token, next) {
      var state = { progress: 0 };

      anime({
        targets: state,
        progress: [0, Math.PI],
        duration: 1320,
        easing: 'cubicBezier(0.32, 0.72, 0, 1)',
        update: function() {
          if (banner.dataset.hatchillBannerLoop !== token) return;

          var lift = Math.sin(state.progress);
          var frame = Math.round(1 + 3 * lift);

          banner.style.boxShadow = 'inset 0 -1px 0 rgba(196, 125, 52, ' + fixed(0.36 + 0.18 * lift) + '), 0 ' + fixed(4 + 3 * lift) + 'px ' + fixed(16 + 8 * lift) + 'px rgba(0, 0, 0, 0.18)';
          banner.style.filter = 'saturate(' + fixed(1 + 0.045 * lift) + ')';

          if (icon) {
            icon.style.transform = 'translateY(' + fixed(-5 * lift) + 'px) scale(' + fixed(1 + 0.055 * lift) + ') rotate(' + fixed(-1.4 * lift) + 'deg)';
          }

          if (copy) {
            copy.style.opacity = fixed(0.92 + 0.08 * lift);
            copy.style.transform = 'translateX(' + fixed(1.6 * lift) + 'px)';
          }

          if (cta) {
            cta.style.boxShadow = 'inset 0 -2px 0 rgba(196, 125, 52, 0.88), 0 0 0 ' + frame + 'px rgba(196, 125, 52, ' + fixed(0.1 + 0.14 * lift) + ')';
            cta.style.filter = 'brightness(' + fixed(1 + 0.045 * lift) + ')';
            cta.style.transform = 'translateY(' + fixed(-4 * lift) + 'px) scale(' + fixed(1 + 0.036 * lift) + ')';
          }
        },
        complete: function() {
          clearBannerFrame(banner);
          next();
        }
      });
    }, 2);
  }

  function runModalIdle(anime, modal) {
    var stage = modal.querySelector('.hatchill-app-modal__stage');
    var icon = modal.querySelector('.hatchill-app-modal__icon');
    var mark = icon && (icon.querySelector('img') || icon.querySelector('span') || icon);
    var cta = modal.querySelector('.hatchill-app-modal__cta');
    var targets = [stage, icon, mark, cta].filter(Boolean);

    anime.remove(targets);

    runLoop(modal, 'hatchillModalLoop', function(token, next) {
      var state = { progress: 0 };

      anime({
        targets: state,
        progress: [0, Math.PI],
        duration: 1480,
        easing: 'cubicBezier(0.32, 0.72, 0, 1)',
        update: function() {
          if (modal.dataset.hatchillModalLoop !== token) return;

          var lift = Math.sin(state.progress);
          var frame = Math.round(1 + 4 * lift);

          if (stage) {
            stage.style.boxShadow = '0 0 0 ' + frame + 'px rgba(196, 125, 52, ' + fixed(0.08 + 0.1 * lift) + '), inset 0 0 0 1px rgba(232, 214, 190, ' + fixed(0.16 + 0.12 * lift) + '), 0 ' + fixed(8 + 4 * lift) + 'px ' + fixed(22 + 10 * lift) + 'px rgba(0, 0, 0, 0.24)';
            stage.style.filter = 'saturate(' + fixed(1 + 0.08 * lift) + ')';
            stage.style.transform = 'translateY(0) scale(' + fixed(1 + 0.018 * lift) + ')';
          }

          if (icon) {
            icon.style.boxShadow = '0 ' + fixed(8 + 3 * lift) + 'px 0 rgba(196, 125, 52, 0.92), 0 0 0 ' + frame + 'px rgba(196, 125, 52, ' + fixed(0.08 + 0.12 * lift) + ')';
            icon.style.filter = 'brightness(' + fixed(1 + 0.04 * lift) + ')';
            icon.style.transform = 'translateY(' + fixed(-2 * lift) + 'px) scale(' + fixed(1 + 0.02 * lift) + ')';
          }

          if (mark) {
            mark.style.filter = 'brightness(' + fixed(1.14 + 0.04 * lift) + ') contrast(1.14) saturate(' + fixed(1.03 + 0.08 * lift) + ')';
            mark.style.transform = 'translateY(' + fixed(-4 * lift) + 'px) rotate(' + fixed(-2.6 * lift) + 'deg) scale(' + fixed(1 + 0.024 * lift) + ')';
          }

          if (cta) {
            cta.style.boxShadow = 'inset 0 -4px 0 rgba(196, 125, 52, 0.96), 0 0 0 ' + frame + 'px rgba(196, 125, 52, ' + fixed(0.08 + 0.12 * lift) + '), 0 ' + fixed(8 + 5 * lift) + 'px ' + fixed(18 + 10 * lift) + 'px rgba(0, 0, 0, 0.2)';
            cta.style.filter = 'brightness(' + fixed(1 + 0.05 * lift) + ')';
            cta.style.transform = 'translateY(' + fixed(-4 * lift) + 'px) scale(' + fixed(1 + 0.03 * lift) + ')';
          }
        },
        complete: function() {
          clearModalFrame(modal);
          next();
        }
      });
    }, 2);
  }

  function revealBanner(banner, animeSrc) {
    banner.hidden = false;
    banner.classList.remove('is-closing');

    window.requestAnimationFrame(function() {
      banner.classList.add('is-visible');
    });

    return loadAnime(animeSrc).then(function(anime) {
      if (!anime) return false;

      var targets = [
        banner,
        banner.querySelector('.hatchill-app-banner__icon'),
        banner.querySelector('.hatchill-app-banner__copy'),
        banner.querySelector('.hatchill-app-banner__cta')
      ].filter(Boolean);

      anime.remove(targets);
      anime.set(targets.slice(1), { opacity: 0, translateY: 8, scale: 0.96 });
      anime.set(banner, { opacity: 0, translateY: -18 });

      anime.timeline({ easing: 'cubicBezier(0.16, 1, 0.3, 1)' })
        .add({ targets: banner, opacity: [0, 1], translateY: [-18, 0], duration: 300 }, 0)
        .add({
          targets: targets.slice(1),
          opacity: [0, 1],
          translateY: [8, 0],
          scale: [0.96, 1],
          delay: anime.stagger(55),
          duration: 310
        }, 70);

      window.setTimeout(function() {
        anime.set(targets.slice(1), { opacity: 1, translateY: 0, scale: 1 });
        runBannerIdle(anime, banner);
      }, 620);

      return true;
    });
  }

  function dismissBanner(banner, animeSrc, callback) {
    delete banner.dataset.hatchillBannerLoop;
    clearBannerFrame(banner);
    banner.classList.remove('is-visible');
    banner.classList.add('is-closing');

    return loadAnime(animeSrc).then(function(anime) {
      if (!anime) {
        finish(callback);
        return false;
      }

      anime.remove([banner, banner.querySelector('.hatchill-app-banner__icon'), banner.querySelector('.hatchill-app-banner__cta')].filter(Boolean));
      anime({
        targets: banner,
        opacity: [1, 0],
        translateY: [0, -10],
        duration: 170,
        easing: 'cubicBezier(0.7, 0, 0.84, 0)',
        complete: function() { finish(callback); }
      });

      return true;
    });
  }

  function revealModal(modal, animeSrc) {
    modal.hidden = false;
    modal.classList.remove('is-closing');

    window.requestAnimationFrame(function() {
      modal.classList.add('is-visible');
    });

    return loadAnime(animeSrc).then(function(anime) {
      if (!anime) return false;

      var backdrop = modal.querySelector('.hatchill-app-modal__backdrop');
      var panel = modal.querySelector('.hatchill-app-modal__panel');
      var stage = modal.querySelector('.hatchill-app-modal__stage');
      var icon = modal.querySelector('.hatchill-app-modal__icon');
      var copy = modal.querySelector('.hatchill-app-modal__identity-copy');
      var text = modal.querySelectorAll('.hatchill-app-modal__kicker, .hatchill-app-modal h2, .hatchill-app-modal h2 + p');
      var chips = modal.querySelectorAll('.hatchill-app-modal__benefits li');
      var cta = modal.querySelector('.hatchill-app-modal__cta');
      var targets = [backdrop, panel, stage, icon, copy, cta].filter(Boolean);

      anime.remove([].slice.call(text).concat([].slice.call(chips)).concat(targets));
      if (backdrop) anime.set(backdrop, { opacity: 0 });
      if (panel) anime.set(panel, { opacity: 0, translateY: 32, scale: 0.98 });
      if (stage) anime.set(stage, { opacity: 0, translateY: 14, scale: 0.975 });
      anime.set([icon, copy].filter(Boolean), { opacity: 0, translateY: 10, scale: 0.96 });
      anime.set(text, { opacity: 0, translateY: 8 });
      anime.set(chips, { opacity: 0, translateY: 8 });
      if (cta) anime.set(cta, { opacity: 0, translateY: 8, scale: 0.97 });

      anime.timeline({ easing: 'cubicBezier(0.16, 1, 0.3, 1)' })
        .add({ targets: backdrop, opacity: [0, 1], duration: 190 }, 0)
        .add({ targets: panel, opacity: [0, 1], translateY: [32, 0], scale: [0.98, 1], duration: 420 }, 0)
        .add({ targets: stage, opacity: [0, 1], translateY: [14, 0], scale: [0.975, 1], duration: 380 }, 90)
        .add({ targets: copy, opacity: [0, 1], translateY: [10, 0], scale: [0.96, 1], duration: 280 }, 150)
        .add({ targets: icon, opacity: [0, 1], translateY: [10, 0], scale: [0.86, 1], rotate: [-3, 0], duration: 380 }, 165)
        .add({ targets: text, opacity: [0, 1], translateY: [8, 0], delay: anime.stagger(35), duration: 250 }, 200)
        .add({ targets: chips, opacity: [0, 1], translateY: [8, 0], delay: anime.stagger(40), duration: 240 }, 280)
        .add({
          targets: cta,
          opacity: [0, 1],
          translateY: [8, 0],
          scale: [0.97, 1],
          duration: 260
        }, 370);

      window.setTimeout(function() {
        if (stage) anime.set(stage, { opacity: 1, translateY: 0, scale: 1 });
        if (icon) anime.set(icon, { opacity: 1, translateY: 0, scale: 1, rotate: 0 });
        if (cta) anime.set(cta, { opacity: 1, translateY: 0, scale: 1 });
        runModalIdle(anime, modal);
      }, 760);

      return true;
    });
  }

  function dismissModal(modal, animeSrc, callback) {
    delete modal.dataset.hatchillModalLoop;
    clearModalFrame(modal);
    var backdrop = modal.querySelector('.hatchill-app-modal__backdrop');
    var panel = modal.querySelector('.hatchill-app-modal__panel');

    modal.classList.remove('is-visible');
    modal.classList.add('is-closing');

    return loadAnime(animeSrc).then(function(anime) {
      if (!anime) {
        finish(callback);
        return false;
      }

      anime.remove([backdrop, panel, modal.querySelector('.hatchill-app-modal__stage'), modal.querySelector('.hatchill-app-modal__icon'), modal.querySelector('.hatchill-app-modal__cta')].filter(Boolean));
      anime.timeline({
        easing: 'cubicBezier(0.7, 0, 0.84, 0)',
        complete: function() { finish(callback); }
      })
        .add({ targets: panel, opacity: [1, 0], translateY: [0, 18], duration: 190 }, 0)
        .add({ targets: backdrop, opacity: [1, 0], duration: 190 }, 0);

      return true;
    });
  }

  window.HatchillAppMotion = {
    revealBanner: revealBanner,
    dismissBanner: dismissBanner,
    revealModal: revealModal,
    dismissModal: dismissModal,
    loadAnime: loadAnime
  };
})();
